var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerTriploaDireita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1105_21969)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 210,
    height: 429,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 210,
    height: 429,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 181.25H79.75C75.6079 181.25 72.25 184.608 72.25 188.75V241.25C72.25 245.392 75.6079 248.75 79.75 248.75H132.25C136.392 248.75 139.75 245.392 139.75 241.25V188.75C139.75 184.608 136.392 181.25 132.25 181.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.875 207.5C95.9816 207.5 98.5 204.982 98.5 201.875C98.5 198.768 95.9816 196.25 92.875 196.25C89.7684 196.25 87.25 198.768 87.25 201.875C87.25 204.982 89.7684 207.5 92.875 207.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75 226.25L121 207.5L79.75 248.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 210,
    height: 210,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 0.5,
    width: 210,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25 72.25H298.75C294.608 72.25 291.25 75.6079 291.25 79.75V132.25C291.25 136.392 294.608 139.75 298.75 139.75H351.25C355.392 139.75 358.75 136.392 358.75 132.25V79.75C358.75 75.6079 355.392 72.25 351.25 72.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.875 98.5C314.982 98.5 317.5 95.9816 317.5 92.875C317.5 89.7684 314.982 87.25 311.875 87.25C308.768 87.25 306.25 89.7684 306.25 92.875C306.25 95.9816 308.768 98.5 311.875 98.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75 117.25L340 98.5L298.75 139.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 219.5,
    width: 210,
    height: 210,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 219.5,
    width: 210,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25 291.25H298.75C294.608 291.25 291.25 294.608 291.25 298.75V351.25C291.25 355.392 294.608 358.75 298.75 358.75H351.25C355.392 358.75 358.75 355.392 358.75 351.25V298.75C358.75 294.608 355.392 291.25 351.25 291.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.875 317.5C314.982 317.5 317.5 314.982 317.5 311.875C317.5 308.768 314.982 306.25 311.875 306.25C308.768 306.25 306.25 308.768 306.25 311.875C306.25 314.982 308.768 317.5 311.875 317.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75 336.25L340 317.5L298.75 358.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1105_21969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerTriploaDireita);
export default __webpack_public_path__ + "static/media/BannerTriploaDireita.4a25c6957b662802ae2352b630244b93.svg";
export { ForwardRef as ReactComponent };